export const CATCHUP_TYPES = {
  CALLBACK: "callback",
  MEETING: "meeting",
  MISSED_CALLS: "missed_calls",
} as const;
